/**
 * UranIA PA — `/auth/logout` (revoca, pulizia storage, rientro alla copertina).
 *
 * Punto d'ingresso indirizzabile per il logout federato — `AppTopbar`
 * continua a chiamare `startLogout()` direttamente (nessun hop extra
 * necessario lì); questa rotta serve a chi vuole *linkare* un logout
 * (es. `/manutenzione`, comunicazioni, redirect da un altro ente) senza
 * dipendere da un bottone montato altrove. Nessuna UI: `startLogout()`
 * chiama `signoutRedirect()` (oidc-client-ts), che porta il browser fuori
 * dalla SPA verso l'`end_session_endpoint` di Keycloak e poi al
 * `post_logout_redirect_uri` configurato in `lib/auth/oidc.ts` (già "la
 * copertina"). Stesso pattern azione-e-basta di `auth.silent-renew.tsx`.
 */

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { createRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { startLogout } from '../lib/auth/login-actions.ts';
import { Route as RootRoute } from './__root.tsx';

function LogoutPage(): JSX.Element {
  const { t } = useTranslation();
  useEffect(() => {
    void startLogout();
  }, []);
  return (
    <section data-testid="auth-logout-page" aria-live="polite">
      <p className="lead">{t('sistema.logout.in_progress')}</p>
    </section>
  );
}

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/auth/logout',
  component: LogoutPage,
});
